import createIcon from '../../createIcon';

/**
 * @component @name Curtains
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTlWM0g0VjE5SDJWMjFIMjJWMTlIMjBaTTguMTkgMTJDMTAuMjMgMTAuNjUgMTEuNjkgOC4wNiAxMS45NSA1SDEyLjA0QzEyLjMgOC4wNiAxMy43NiAxMC42NSAxNS44IDEyQzEzLjc2IDEzLjM1IDEyLjMgMTUuOTQgMTIuMDQgMTlIMTEuOTVDMTEuNjkgMTUuOTQgMTAuMjMgMTMuMzUgOC4xOSAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Curtains = createIcon('Curtains', [
  [
    'path',
    {
      d: 'M20 19V3H4V19H2V21H22V19H20ZM8.19 12C10.23 10.65 11.69 8.06 11.95 5H12.04C12.3 8.06 13.76 10.65 15.8 12C13.76 13.35 12.3 15.94 12.04 19H11.95C11.69 15.94 10.23 13.35 8.19 12Z',
      key: '7362ty',
    },
  ],
]);

export default Curtains;
